import { useEffect, useRef } from 'react';
import { Room } from 'twilio-video';
import { Callback } from '../../../types';

export default function useHandleOnDisconnect(room: Room | null | undefined, onDisconnect: Callback) {
  const onDisconnectRef = useRef(onDisconnect);
  onDisconnectRef.current = onDisconnect;

  useEffect(() => {
    if (!room) return;

    const handleDisconnect = () => {
      onDisconnectRef.current();
    };

    room.on('disconnected', handleDisconnect);

    return () => {
      room.off('disconnected', handleDisconnect);
    };
  }, [room]); // track the room object so cleanup runs whenever it changes
}
